module.exports = __webpack_public_path__ + "img/kdLogoM_EN.9667c3a0.png";